// pipe: perf — ONE memoized "is this route family active" hook shared by every PIPE sidebar
// button. The inline `workbench.location$.selector(...)` idiom minted a fresh derived LiveData
// (and a fresh subscription in useLiveData) on every render; memoizing it on its real inputs
// keeps the selector stable across renders. `exact` preserves the Records button's exact-path
// match (`===`) — the family buttons use the default prefix match (`startsWith`).
import { useLiveData } from '@toeverything/infra';
import { useMemo } from 'react';

import type { Workbench } from '../../modules/workbench';

export function useNavPrefixActive(
  workbench: Workbench,
  prefix: string,
  exact = false
): boolean {
  const active$ = useMemo(
    () =>
      workbench.location$.selector(l =>
        exact ? l.pathname === prefix : l.pathname.startsWith(prefix)
      ),
    [workbench, prefix, exact]
  );
  return useLiveData(active$);
}
